import { render, staticRenderFns } from "./AQInsightsByAreaComponent.vue?vue&type=template&id=724005cd"
import script from "./AQInsightsByAreaComponent.vue?vue&type=script&lang=js"
export * from "./AQInsightsByAreaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports